const today = () => new Date().toISOString().slice(0, 10);

const E = (id, category, item, current, need = "Y", retOverride = "") => ({ id, category, item, current, need, retOverride });

export const ASSET_ROWS = [["cash", "Cash & Savings"], ["primaryResidence", "Primary Residence"], ["secondProperty", "Second Property"], ["vehicles", "Vehicles"], ["other", "Other Assets"]];
export const LIAB_ROWS = [["mortgage", "Mortgage"], ["carLoan", "Car Loan"], ["loc", "Line of Credit"], ["studentLoan", "Student Loan"], ["personalLoans", "Personal Loans"], ["other", "Other Debts"]];
export const FINAL_ROWS = [["funeral", "Funeral Expenses"], ["legal", "Legal Fees"], ["emergency", "Emergency Fund"], ["education", "Education Fund"], ["otherTax", "Other (Tax & Other)"]];
export const ACCOUNT_TYPES = ["RRSP", "TFSA", "FHSA", "RESP", "RDSP", "LIRA", "RRIF", "Non-registered", "Pension", "Other savings"];
export const PURPOSES = ["Retirement", "Education", "Home purchase", "Emergency", "Disability", "Estate", "Other goal"];
export const DEFAULT_PURPOSE = { RESP: "Education", FHSA: "Home purchase", RDSP: "Disability" };
export const OWNERS = ["Client", "Spouse", "Joint"];
export const HEALTH_ITEMS = [["drugs", "Prescription Drugs"], ["dental", "Dental"], ["vision", "Vision"], ["paramedical", "Paramedical"], ["hospital", "Hospital / Semi-private"], ["travel", "Travel Medical"]];
export const HEALTH_OPTIONS = ["Group", "Individual", "None"];
export const MARITAL = ["Single", "Married", "Common-law", "Separated", "Divorced", "Widowed"];
export const GENDERS = ["Male", "Female", "Other"];
export const PROVINCES = ["AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT"];

const row = (amount, use = "N") => ({ amount, use });

// Original v1 defaults copied from "Client_Dashboard_FNA.xlsm" (migrated to v2 on use)
export const templateV1 = (name = "Client 1") => ({
  profile: { name, age: 38, meetingDate: today(), currency: "CAD", advisorName: "Shalindra K C", remarks: "" },
  expenses: {
    inflation: 2.5,
    items: [
      E("rent", "Housing", "Mortgage / Rent", 2100, "N", 0), E("e2", "Housing", "Property Tax", 0), E("e3", "Housing", "Home Insurance", 160),
      E("e4", "Housing", "Utilities", 325), E("e5", "Housing", "Maintenance", 30), E("e6", "Food", "Groceries", 1500),
      E("e7", "Food", "Dining Out", 200), E("e8", "Transportation", "Fuel", 150), E("e9", "Transportation", "Insurance", 175),
      E("e10", "Transportation", "Maintenance", 50), E("e11", "Transportation", "Public Transit", 75),
      E("e12", "Healthcare", "Insurance Premium", 450, "Y", 0), E("e13", "Healthcare", "Medications", 50), E("e14", "Healthcare", "Dental", 0),
      E("e15", "Healthcare", "Vision", 0), E("e16", "Healthcare", "Other Medical", 0), E("e17", "Lifestyle", "Phone", 125),
      E("e18", "Lifestyle", "Internet", 100), E("e19", "Lifestyle", "Entertainment", 30), E("e20", "Lifestyle", "Travel", 500),
      E("e21", "Lifestyle", "Hobbies", 0), E("e22", "Other", "Gifts / Donations", 0), E("e23", "Taxes", "Income Taxes (annual)", 0, "Y", 0),
      E("e24", "Banking", "Fees", 0),
    ],
  },
  insurance: {
    annualIncome: 70000, incomePct: 50, yearsNeeded: 20, incomeMethod: "Y", expenseMethod: "Y",
    assets: { tfsa: row(8000), rrsp: row(10500), cash: row(4000), primaryResidence: row(0), secondProperty: row(0), nonReg: row(0) },
    permanentLife: 90000, termLife: 0, criticalIllness: 50000,
    liabilities: { mortgage: row(0, "Y"), carLoan: row(0, "Y"), loc: row(0, "Y"), studentLoan: row(0, "Y"), personalLoans: row(0, "Y") },
    finals: { funeral: row(25000, "Y"), legal: row(5000, "Y"), emergency: row(9000, "Y"), education: row(0, "Y"), otherTax: row(10000, "Y") },
  },
  investment: {
    lifeExpectancy: 85, retirementAge: 65, currentSalary: 0, cppMonthly: 350, yearsInCanada: 38,
    pensionValue: 0, pensionYour: 210, pensionEmployer: 210, pensionRor: 6, employerPensionMonthly: 0,
    rrspContrib: 3000, rrspRor: 10, tfsaContrib: 3000, tfsaRor: 10, nonRegContrib: 0, nonRegRor: 4,
    postRetRor: 4, otherIncomeExpected: 0, otherMonthlyIncome: 0, targetRor: 8,
  },
});
